import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    currency: translate({ id: 'settings.languageAndFormats.edit.fields.currency.label' }),
    language: translate({ id: 'settings.languageAndFormats.edit.fields.language.label' }),
    dateFormat: translate({ id: 'settings.languageAndFormats.view.dateFormat' }),
    timeFormat: translate({ id: 'settings.languageAndFormats.view.timeFormat' }),
    distanceFormat: translate({
      id: 'settings.languageAndFormats.view.distanceFormat',
    }),

    distanceFormatValue: (format: uui.domain.DistanceFormat) =>
      translate({
        id:
          format === 'METRIC' ? 'global.unitsOfMeasure.kilometers' : 'global.unitsOfMeasure.miles',
      }),
    currencyRequired: translate({
      id: 'settings.languageAndFormats.edit.errors.currency.required',
    }),
    currencyInvalid: translate({ id: 'settings.languageAndFormats.edit.errors.currency.valid' }),
  }))

  return api
}

export type Texts = ReturnType<typeof useTexts>
